import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';

import { AuthenticationService } from './authentication.service';

enum HierarchyLevel {
	Administrador = 9,
	DirectorGeneral = 8,
	EncargadoNivelCentral = 7,
	DirectorRegional = 6,
	DirectorMunicipal = 5,
	DirectorEstablecimiento = 4,
	EncargadoAtenciónUsuario = 3,
	AuxiliarAtenciónUsuario = 2,
	Encuestador = 1
}

@Injectable({
	providedIn: 'root'
})

export class AdminAccessCheckService implements CanActivate {
	hasAdminAccess = !!this.authenticationService.currentUser
		? this.authenticationService.currentUser.profile.role.hierarchyLevel >= HierarchyLevel.AuxiliarAtenciónUsuario
		: false;
	invalidUser = this.authenticationService.currentUser.profile.invalid_user;

	constructor(private authenticationService: AuthenticationService, private router: Router) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.hasAdminAccess) {
			return true;
		} else {
			this.router.navigate(
				['public/unauthorized']);
		}
	}
}
